import React from "react";
import useCreateDevPaymentMutation from "./../data-access/business/useCreateDevPaymentMutation";
import { Box, Button } from "@mui/material";

export type TTestDiasProps = {
  ri3?: string;
  amount: string;
};
function TestDias(props: TTestDiasProps) {
  const { ri3, amount } = props;
  const { mutate } = useCreateDevPaymentMutation();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "40vh",
        minWidth: "60vw",
      }}
    >
      <Button onClick={() => mutate({ ri3, amount })}>Test Dias</Button>
    </Box>
  );
}

export default TestDias;
